import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { catchError, finalize, map, of } from 'rxjs';

import { LoadingService } from '../../../services/loading.service';
import { TaxProfileService } from '../services/tax-profile.service';

/**
 * Ensures that when user visits any collaboration children route
 * it will fetch tax profile
 */
export const fetchTaxProfileGuard: CanActivateChildFn = (route, state) => {
  const router = inject(Router);

  const taxProfileService = inject(TaxProfileService);
  const loadingService = inject(LoadingService);

  const loaderId = 'tax-profile-guard-loading';
  loadingService.setLoading(loaderId, true);

  return taxProfileService.getOrFetchProfile().pipe(
    map(() => true),
    catchError(() => of(router.createUrlTree(['/collaboration/profile-error']))),
    finalize(() => loadingService.setLoading(loaderId, false))
  );
};
